module.exports = __webpack_public_path__ + "static/media/arrow_down.86078566.svg";